import { SettingsItemImage } from '@elipssolution/harfang';
import { Control, Controller } from 'react-hook-form';

import { DefaultFormType, ImageFieldType } from '../../types/form';

type ImageFormFieldProps = {
	control: Control<DefaultFormType>;
	specificField: ImageFieldType;
};

const ImageFormField = ({
	control,
	specificField: { key, description, label, name, value, onChange },
}: ImageFormFieldProps) => (
	<Controller
		control={control}
		render={({ field: { value: formValue, onChange: formOnchange, ...field } }) => {
			const handleChange = (image?: File) => {
				if (!image) return;

				const [extension] = image.name.split('.').slice(-1);
				const fileName = `${key}.${extension}`;

				onChange(image);
				formOnchange(fileName);
			};

			return (
				<SettingsItemImage
					{...field}
					key={key}
					description={description}
					label={label}
					image={value}
					previewHeight={86}
					previewWidth={86}
					onChange={handleChange}
				/>
			);
		}}
		name={name}
	/>
);

export default ImageFormField;
